// extracted by mini-css-extract-plugin
export default {"section":"TemplateForm_section__yq1rr","clearButton":"TemplateForm_clearButton__3q46X"};